import React, { useEffect, useState } from "react";
import sourceOneRestRequest from "../../../utilities/requests/SourceOneRestRequest";
import { ECLUserInfo } from "../../../eclComponents";
import SearchableNodes from "./searchableNodes";
import { ReactFlowProvider } from "@xyflow/react";
import ExplorerPreview from "./components/ExplorerPreview";

export default function Explorer() {
   const [nodes, setNodes] = useState([]);
   const [searchables, setSearchables] = useState([]);
   const [previewNode, setPreviewNode] = useState(null);

   useEffect(() => {
      //let's get all the projects
      sourceOneRestRequest({ query_type: "objects" }).then((object) => {
         sourceOneRestRequest({ query_type: "attributes" }).then(
            (attributes) => {
               const newSearchables = {
                  name: {
                     name: "name",
                     type: "text",
                     active: false,
                     focused: false,
                     selections: [],
                  },
                  type: {
                     name: "type",
                     type: "text",
                     active: false,
                     focused: false,
                     selections: [],
                  },
               };
               const newNodeLength = Object.keys(object).length;

               const newNodes = Object.entries(object)
                  .filter((keyVal) => keyVal[1].object_type !== "poly")
                  .map(([k, v], i) => {
                     const nameSelections = newSearchables["name"].selections;
                     if (
                        !nameSelections.find(
                           (n) => n.searchableString === v.name,
                        )
                     ) {
                        nameSelections.push({
                           id: v.name,
                           searchableString: v.name,
                           jsx: v.name,
                           selected: true,
                        });
                     }

                     const typeSelections = newSearchables["type"].selections;
                     if (
                        !typeSelections.find(
                           (n) => n.searchableString === v.object_type,
                        )
                     ) {
                        typeSelections.push({
                           id: v.object_type,
                           searchableString: v.object_type,
                           jsx: v.object_type,
                           selected: true,
                        });
                     }

                     const decodedAttributes = {};
                     Object.entries(v.attributes).forEach(([k, v]) => {
                        const attributeSearchable =
                           newSearchables[attributes[k].name];
                        if (!attributeSearchable) {
                           newSearchables[attributes[k].name] = {
                              name: attributes[k].name,
                              type:
                                 attributes[k].type === "date_time"
                                    ? "timestamp"
                                    : "text",
                              active: false,
                              focused: false,
                              selections: [],
                              min: new Date(),
                              max: new Date(0),
                              currentMin: new Date(),
                              currentMax: new Date(0),
                           };
                        }

                        if (attributes[k].type === "username") {
                           let textSearchable =
                              newSearchables[attributes[k].name].selections;
                           if (
                              !textSearchable.find(
                                 (n) =>
                                    n.searchableString ===
                                    String(
                                       attributes[k].values
                                          ? attributes[k].values.find(
                                               (x) => x.key === v,
                                            )?.value
                                          : v,
                                    ),
                              )
                           ) {
                              textSearchable.push({
                                 id: String(
                                    attributes[k].values
                                       ? attributes[k].values.find(
                                            (x) => x.key === v,
                                         )?.value
                                       : v,
                                 ),
                                 searchableString: attributes[k].values
                                    ? String(
                                         attributes[k].values.find(
                                            (x) => x.key === v,
                                         )?.value,
                                      )
                                    : String(v),
                                 jsx: <ECLUserInfo user={v} />,
                                 selected: true,
                              });
                           }
                        } else if (attributes[k].type === "date_time") {
                           let dateSearchable =
                              newSearchables[attributes[k].name];
                           if (dateSearchable.min > new Date(v)) {
                              dateSearchable.min = new Date(v).valueOf();
                              dateSearchable.currentMin = new Date(v).valueOf();
                           }

                           if (dateSearchable.max < new Date(v)) {
                              dateSearchable.max = new Date(v).valueOf();
                              dateSearchable.currentMax = new Date(v).valueOf();
                           }
                        } else {
                           let textSearchable =
                              newSearchables[attributes[k].name].selections;
                           if (
                              !textSearchable.find(
                                 (n) =>
                                    n.id ===
                                    String(
                                       attributes[k].values
                                          ? attributes[k].values.find(
                                               (x) => x.key === v,
                                            )?.value
                                          : v,
                                    ),
                              )
                           ) {
                              textSearchable.push({
                                 id: String(
                                    attributes[k].values
                                       ? attributes[k].values.find(
                                            (x) => x.key === v,
                                         )?.value
                                       : v,
                                 ),
                                 searchableString: attributes[k].values
                                    ? String(
                                         attributes[k].values.find(
                                            (x) => x.key === v,
                                         )?.value,
                                      )
                                    : String(v),
                                 jsx: String(v),
                                 selected: true,
                              });
                           }
                        }

                        if (attributes[k].type === "date_time") {
                           decodedAttributes[attributes[k].name] = new Date(
                              v,
                           ).valueOf();
                        } else {
                           decodedAttributes[attributes[k].name] = attributes[k]
                              .values
                              ? attributes[k].values.find((x) => x.key === v)
                                   ?.value
                              : v;
                        }
                     });
                     return {
                        id: k,
                        type: "customNode",
                        data: {
                           ...v,
                           id: k,
                           label: v.name,
                           searchables: {
                              name: v.name,
                              type: v.object_type,
                              ...decodedAttributes,
                           },
                           attributes: null,
                        },
                        position: {
                           x: 250 * (i % Math.floor(Math.sqrt(newNodeLength))),
                           y:
                              100 *
                              Math.floor(
                                 i / Math.floor(Math.sqrt(newNodeLength)),
                              ),
                        },
                     };
                  });
               setSearchables(newSearchables);
               setNodes(newNodes);
            },
         );
      });
   }, []);

   return (
      <div className="explorer-container">
         <div className="searchable-node-container">
            <ReactFlowProvider>
               <SearchableNodes
                  nodes={nodes}
                  setNodes={setNodes}
                  searchables={searchables}
                  setSearchables={setSearchables}
                  setPreviewNode={setPreviewNode}
               />
            </ReactFlowProvider>
         </div>
         <div className="preview-container">
            <label>Preview</label>
            <ExplorerPreview node={previewNode} />
         </div>
      </div>
   );
}
